// Dependencies
import React from 'react';
import { ThemeContext } from '../../../../components/theme/Theme.jsx';
import { connect } from 'react-redux';
import radium from 'radium';
import { removeTicketsByEventUuid } from '../../../../redux/shoppingCartReducer';

// Styles
import './ActionBar.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ActionBar(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			margin: '1.2em 0 0',
			padding: '.8em 0 0',
			borderTop: '1px solid',
			borderColor: context.themeManager.value('shopping-cart-action-bar', 'borderColorActionBar', 'shopping-cart-action-bar-border-color'),
		},
		icon: {
			fontSize: context.themeManager.value('shopping-cart-action-bar', 'iconFontSize', 'font-size-100'),
			color: context.themeManager.value('shopping-cart',
					'iconEditColor', 'fg-color-icon-highlight'),
			padding: '.2em 0'
		},
		actionName: {
			color: context.themeManager.value('shopping-cart-action-bar', 'color', 'fg-color-text-highlight'),
			fontWeight: '600',
			padding: '0 0 0 .3em',
			fontSize: context.themeManager.valueOrDefault('shopping-cart-action-bar', 'fontSize', null,'0.8rem'),
			lineHeight: '1rem',
		},
	};
	return (
		<div style={style.container} className="action-bar">
			<a className="action-bar__action--edit" href={props.eventUrl}
				aria-label={"Anzahl Tickets für Veranstaltung" + props.eventTitle +" ändern"}
				title={"Anzahl Tickets für Veranstaltung" + props.eventTitle +" ändern"}>
				<FontAwesomeIcon
					icon="pencil"
					style={style.icon}
				/>
				<div style={style.actionName} id={"change-tickets"}>ändern</div>
			</a>
			<button type='button'
					className="action-bar__action--delete leo__button-sample"
					onClick={props.onDeleteEventClicked}
					aria-label={"Tickets für Event " + props.eventTitle + "löschen"}
					title={"Tickets für Event " + props.eventTitle + "löschen"}
					name={"Tickets für Event " + props.eventTitle + "löschen"}
			>
				<FontAwesomeIcon
					icon="trash"
					style={style.icon}
				/>
				<div style={style.actionName}>löschen</div>
			</button>
		</div>
	);
}

// ------------------------------
// Redux Connection
// ------------------------------
const mapDispatchToProps = (dispatch, ownProps) => ({
	onDeleteEventClicked: () => {
		dispatch(removeTicketsByEventUuid(ownProps.eventUuid));
	},
});

export default connect(null, mapDispatchToProps)(radium(ActionBar));
